import { Component } from '@angular/core';

@Component({
  selector: 'bemum-root',
  template: '<router-outlet></router-outlet>',
  standalone: false,
})
export class AppComponent {
  title = 'patient-spa';
}
